import React, { useState } from "react";

import { Button, Stack } from "@mui/material";
import { NumberInput } from "components/forms";
import { ProgressOverlay } from "components/Progress-overlay/ProgressOverlay";
import { useActionHook, useModals } from "hooks";
import { useDealActions, useDealIdSelector, useDealSuccessFeeSettingSelect, useReportsActions } from "store";

export interface State {
  hurdle_1: number | null;
  catch_up_1: number | null;
  carry_1: number | null;
}

interface Props {
  onClose: () => void;
}

export const CarriedForm: React.FC<Props> = ({ onClose }) => {
  const { hurdle_1, catch_up_1, carry_1 } = useDealSuccessFeeSettingSelect() || {};
  const [state, setState] = useState<State>({
    hurdle_1: hurdle_1 ?? null,
    catch_up_1: catch_up_1 ?? null,
    carry_1: carry_1 ?? null
  });

  const dealId = useDealIdSelector();
  const { calcManageInterestsAction } = useReportsActions();
  const { getDealAndStoreAction } = useDealActions();
  const { errorModal } = useModals();

  const { action, loading } = useActionHook(calcManageInterestsAction, {
    onReject: () => {
      errorModal({ msg: "Validation Error" });
    },
    onSuccess: () => {
      if (dealId) {
        getDealAndStoreAction(dealId);
      }
      onClose();
    }
  });

  const handleSubmit = async () => {
    if (!dealId) return;
    action({
      deal_id: dealId,
      hurdle_1: state.hurdle_1 ?? 0,
      catch_up_1: state.catch_up_1 ?? 0,
      carry_1: state.carry_1 ?? 0
    });
  };

  return (
    <ProgressOverlay containerSX={{ display: "flex", flexDirection: "column", flexGrow: 1 }} inProgress={loading}>
      <Stack sx={{ flexGrow: 1, p: "20px", gap: "20px" }}>
        <NumberInput
          fullWidth
          label="Hurdle"
          placeholder="%"
          value={state.hurdle_1}
          numberInputProps={{
            decimalScale: 2,
            suffix: "%",
            onValueChange: ({ floatValue }) => setState((prevState) => ({ ...prevState, hurdle_1: floatValue ?? null }))
          }}
        />
        <NumberInput
          fullWidth
          label="Catch-up"
          placeholder="%"
          value={state.catch_up_1}
          numberInputProps={{
            decimalScale: 2,
            suffix: "%",
            onValueChange: ({ floatValue }) =>
              setState((prevState) => ({ ...prevState, catch_up_1: floatValue ?? null }))
          }}
        />
        <NumberInput
          fullWidth
          label="Carry"
          placeholder="%"
          value={state.carry_1}
          numberInputProps={{
            decimalScale: 2,
            suffix: "%",
            onValueChange: ({ floatValue }) => setState((prevState) => ({ ...prevState, carry_1: floatValue ?? null }))
          }}
        />
      </Stack>
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "20px",
          p: "20px",
          boxShadow: "3px -2px 10px 0px rgba(10, 49, 66, 0.20)"
        }}
      >
        <Button variant="outlined">Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Apply
        </Button>
      </Stack>
    </ProgressOverlay>
  );
};
